import OrderOptimizerListRequest, {
  OrderOptimizerListRequestQueryParams,
} from "./order-optimizer-list.request";

const createQueryParams = (
  request: OrderOptimizerListRequest,
): OrderOptimizerListRequestQueryParams => {
  return {
    limit: request.limit,
    offset: request.offset,
    orderHumanId: request.orderHumanId,
    maximumDelay: request.maximumDelay,
    maximumHaltingTime: request.maximumHaltingTime,
    mergePlanEntries: request.mergePlanEntries,
    ignoreCargo: request.ignoreCargo,
    ignoreOnlyWithCargo: request.ignoreOnlyWithCargo,
    ignoreOnlyWithTaxi: request.ignoreOnlyWithTaxi,
    ignoreTaxi: request.ignoreTaxi,
    excludeStatus: request.excludeStatus,
    status: request.status,
  };
};

const orderOptimizerListRequestFactory = { createQueryParams };

export default orderOptimizerListRequestFactory;
